// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QisMza4VZ3A0kkIoIRqJ p{color:var(--beam-color-subtle)}`, "",{"version":3,"sources":["webpack://./../../components/react/src/components/LegalDisclosure/legalDisclosure.module.scss"],"names":[],"mappings":"AACE,wBACE,8BAAA","sourcesContent":[".legalDisclosureContainer {\n  p {\n    color: var(--beam-color-subtle);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"legalDisclosureContainer": `QisMza4VZ3A0kkIoIRqJ`
};
export default ___CSS_LOADER_EXPORT___;
